import ReactDOM from "react-dom";
import { Fragment, useEffect, useState } from "react";
import Location from "../locationLibrary/Location";
import withActiveCarouselState from "../HOC/withActiveCarouselState";
import axios from 'axios';

const container = document.getElementById('il-locations-container');

import React from 'react';

const Category = (props) => {
    const [locations, setLocations] = useState([]);

    useEffect(() => {
        axios.get("/api/" + type + "/" + category + "/" + page + "?per_page=20")
            .then(response => {
                setLocations(response.data.paginator.data);
            })
            .catch(err => console.log(err));
    }, []);
    return (
        <Fragment>
            {locations.map((location, key) => (
                <Location
                    {...location}
                    key={key}
                    categorySlug={category}
                    className="col-sm-6 col-md-4 col-lg-3 px-2 mb-3 il-sm-carousel-container"
                    smallScreen={props.smallScreen}
                    isActive={props.activeLocations.includes(location.id)}
                    onActiveCallback={props.onActiveCallback}
                />
            ))}
        </Fragment>
    );
}

const Test = withActiveCarouselState(Category);


ReactDOM.render(
    <Test />,
    container,
);
